"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const MedicalLocationTimes_1 = __importDefault(require("../location/MedicalLocationTimes"));
const TimeManagement = ({ location }) => {
    const [tabs] = (0, react_1.useState)("medical_location_times");
    return ((0, jsx_runtime_1.jsx)("div", { children: tabs === "medical_location_times" && (0, jsx_runtime_1.jsx)(MedicalLocationTimes_1.default, {}) }));
};
exports.default = TimeManagement;
